module.exports = __webpack_public_path__ + "img/bar-chart.894cc9c7.svg";